import React from "react";
import {Card, CardBody} from "reactstrap";
import SelectableTask from "./SelectableTask";
import "../styles/Task.css"
import FileTask from "./FileTask";
import ReadTask from "./ReadTask";
import MultiTextTask from "./MultiTextTask";
import CustomSelectPlusInputTableTask from "./CustomSelectPlusInputTableTask";

const Task = ({type, title, description, options, correctOptionIds, display, files, subTasks, explanation, correctValues,
                  inputType, style, showCorrect = false}) => {
    const renderTask = () => {
        switch (type) {
            case 'select':
            case 'checkbox':
                return <SelectableTask title={title} description={description} options={options} explanation={explanation} type={type}
                                     correctOptionIds={correctOptionIds} display={display} showCorrect={showCorrect}/>
            case 'radio':
                return <SelectableTask title={title} description={description} options={options} explanation={explanation}
                                     correctOptionIds={correctOptionIds} type={type} display={display} showCorrect={showCorrect}/>
            case 'file':
                return <FileTask title={title} description={description} files={files} showCorrect={showCorrect} explanation={explanation}/>
            case 'highlight':
                return <SelectableTask title={title} description={description} options={options} explanation={explanation}
                                     correctOptionIds={correctOptionIds} type={type} showCorrect={showCorrect} display={display}/>
            case 'read':
                return <ReadTask title={title} description={description} explanation={explanation}
                                 showCorrect={showCorrect} />
            case 'customSelectPlusInputTable':
                return <CustomSelectPlusInputTableTask title={title} description={description} explanation={explanation}
                                                       showCorrect={showCorrect}/>
            case 'multiText':
                return <MultiTextTask title={title} description={description} explanation={explanation} inputType={inputType}
                                      showCorrect={showCorrect} correctValues={correctValues}/>
            default:
                return <div>Task type <b>{type}</b> is unimplemented</div>
        }
    }

    const renderSubTasks = () => {
        return subTasks.map((task, index) => (<Task {...task} key={index} showCorrect={showCorrect}/>))
    }

    return <Card className={`Task ${style || ''}`}>
        <CardBody>
            {renderTask()}
            {subTasks? renderSubTasks() : undefined}
        </CardBody>
    </Card>
}

export default Task;
